export const retirementGlossaryTermStandard = {
  sys: {
    id: 'HNypHqeCMiNdxBKQFYsVN',
  },
  internalTitle: '401k term [Billy]',
  title: '401(k)',
  sectionsCollection: {
    items: [
      {
        __typename: 'SimpleRichTextSection',
        sys: {
          id: '5dCH9jtwkCMmaP9qyt3E5x',
        },
        content: {
          json: {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value: 'What is a 401(k)?',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'heading-2',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value:
                      'In short: A 401(k) is a retirement savings account that you can get through work. A 401(k) allows employees to set aside a percentage of their salary for retirement and get tax benefits for doing so.',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'paragraph',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value: 'What else should I know?',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'paragraph',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        content: [
                          {
                            data: {},
                            marks: [],
                            value:
                              'Roughly 60 million people actively contribute to a 401(k).',
                            nodeType: 'text',
                          },
                        ],
                        nodeType: 'paragraph',
                      },
                    ],
                    nodeType: 'list-item',
                  },
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        content: [
                          {
                            data: {},
                            marks: [],
                            value:
                              'Historically, small and medium-sized businesses have been less likely to offer one. At Human Interest, we’re helping to change that by making it easier and more affordable for businesses and their employees.',
                            nodeType: 'text',
                          },
                        ],
                        nodeType: 'paragraph',
                      },
                    ],
                    nodeType: 'list-item',
                  },
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        content: [
                          {
                            data: {},
                            marks: [],
                            value:
                              '401(k)s have been around for more than 40 years and get their name from the section of the IRS code where they were first introduced: Section 401(k).',
                            nodeType: 'text',
                          },
                        ],
                        nodeType: 'paragraph',
                      },
                    ],
                    nodeType: 'list-item',
                  },
                ],
                nodeType: 'unordered-list',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value: 'Why is my employer offering a 401(k)?',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'heading-2',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value:
                      'A 401(k) is attractive to both employees and employers. 88% of employees say a 401(k) is a must-have when looking for a job, so one of the primary reasons companies offer 401(k) plans is to attract and retain top talent. Employees also benefit from the tax advantages of a 401(k) -- and so do employers. Just like employees, employers get tax advantages from savings they put into a 401(k). The IRS also gives them tax credits for starting up and offering a 401(k) plan to their employees.',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'paragraph',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value: '',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'paragraph',
              },
            ],
            nodeType: 'document',
          },
        },
        topPadding: 64,
        bottomPadding: 32,
        textAlignment: 'left',
        cta: {
          sys: {
            id: '7HvupZcxgi84NpergMKsJP',
          },
          type: 'link',
          variant: null,
          label: 'Safe harbor 401(k) plans',
          url: '/solutions/safe-harbor-401k-plans/',
          openInNewTab: false,
        },
      },
      {
        __typename: 'CtaBanner',
        sys: {
          id: '6X3mVVzG99KMO3UBNvdmeo',
        },
        disclosures: null,
        backgroundColor: 'white',
        alignment: 'center',
        topPadding: 96,
        bottomPadding: 96,
        heading: '401k Stuff',
        subheading: null,
        valueProps: null,
        cta: {
          sys: {
            id: 'ue3umbeuue4zKXsk5m2Eq',
          },
          type: 'button',
          variant: 'primary',
          label: 'Connect with our team',
          url: 'https://go.humaninterest.com/become-a-partner/financial-advisors',
          openInNewTab: false,
        },
      },
      {
        __typename: 'SectionLearningCenterRelatedArticles',
        title: 'Related Articles',
        articlesCollection: {
          items: [
            {
              sys: {
                id: '2MJQUgY51vgGa7ZvvSv1Tr',
              },
              title: '401(k) deadlines for employers',
              lastModified: '2023-06-28T17:33:47.902Z',
              categories: ['employers'],
              subcategories: ['401k-compliance-and-administration'],
              resourceType: 'Guides',
              resource: {
                __typename: 'LearningCenterGuide',
                slug: '401k-deadlines',
                image: {
                  url: 'https://images.ctfassets.net/tj9jxg7kaxby/1oOA7vY4ir5gbIoUTdIuBk/c95a1401c339675f8f46e90ca9e84e71/401_k__deadlines_for_employers_-_blue_2x.png',
                },
              },
            },
            {
              sys: {
                id: '5rNy6d48eMBHyZq8c8wUOz',
              },
              title: '401(k) Rules for Employers: Requirements and Guidelines',
              lastModified: '2023-09-18T18:34:54.945Z',
              categories: ['employers'],
              subcategories: ['starting-a-401k'],
              resourceType: 'Articles',
              resource: {
                __typename: 'LearningCenterArticle',
                slug: '401k-basics-for-employers',
                image: {
                  url: 'https://images.ctfassets.net/tj9jxg7kaxby/7l9XJHxgkmUitYKunsZHUY/0c17d1d81ee529c846ce433218a44105/401k-Basics.jpg',
                },
              },
            },
          ],
        },
      },
    ],
  },
};
